"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectTypes = void 0;
var ObjectTypes;
(function (ObjectTypes) {
    ObjectTypes[ObjectTypes["UNKNOWN"] = 0] = "UNKNOWN";
    ObjectTypes[ObjectTypes["PRESENTATION"] = 1] = "PRESENTATION";
    ObjectTypes[ObjectTypes["SLIDE"] = 2] = "SLIDE";
    ObjectTypes[ObjectTypes["IMAGE"] = 3] = "IMAGE";
    ObjectTypes[ObjectTypes["DIAGRAM"] = 4] = "DIAGRAM";
    ObjectTypes[ObjectTypes["THEME"] = 5] = "THEME";
    ObjectTypes[ObjectTypes["SLIDEMASTER"] = 6] = "SLIDEMASTER";
    ObjectTypes[ObjectTypes["SLIDELAYOUT"] = 7] = "SLIDELAYOUT";
    ObjectTypes[ObjectTypes["NOTESLIDE"] = 8] = "NOTESLIDE";
    ObjectTypes[ObjectTypes["NOTEMASTER"] = 9] = "NOTEMASTER";
    ObjectTypes[ObjectTypes["HANDOUTMASTER"] = 10] = "HANDOUTMASTER";
    ObjectTypes[ObjectTypes["OLEOBJECT"] = 11] = "OLEOBJECT";
    ObjectTypes[ObjectTypes["CHART"] = 12] = "CHART";
    ObjectTypes[ObjectTypes["TABLENATIVE"] = 13] = "TABLENATIVE";
    ObjectTypes[ObjectTypes["DATASOURCE"] = 14] = "DATASOURCE";
    ObjectTypes[ObjectTypes["EMBEDDED_EXCEL_CHART"] = 15] = "EMBEDDED_EXCEL_CHART";
    ObjectTypes[ObjectTypes["EXCEL_CHART"] = 16] = "EXCEL_CHART";
    ObjectTypes[ObjectTypes["DATASOURCE_MAPPING"] = 17] = "DATASOURCE_MAPPING";
    ObjectTypes[ObjectTypes["FORM_DEFINITION"] = 18] = "FORM_DEFINITION";
    ObjectTypes[ObjectTypes["SLIDE_GROUP"] = 19] = "SLIDE_GROUP";
    ObjectTypes[ObjectTypes["PERSONALIZATION"] = 21] = "PERSONALIZATION";
    ObjectTypes[ObjectTypes["VARIABLE_LIST"] = 22] = "VARIABLE_LIST";
    ObjectTypes[ObjectTypes["TEXTSHAPE"] = 24] = "TEXTSHAPE";
    ObjectTypes[ObjectTypes["MULTI_SLIDES"] = 26] = "MULTI_SLIDES";
    ObjectTypes[ObjectTypes["MINIFORM_DEFINITION"] = 27] = "MINIFORM_DEFINITION";
    ObjectTypes[ObjectTypes["MSWORD"] = 30] = "MSWORD";
    ObjectTypes[ObjectTypes["RESOURCE"] = 25] = "RESOURCE";
    ObjectTypes[ObjectTypes["BUNDLE"] = 40] = "BUNDLE";
    ObjectTypes[ObjectTypes["OTHER"] = 99] = "OTHER";
    ObjectTypes[ObjectTypes["FOLDER"] = 50] = "FOLDER";
})(ObjectTypes = exports.ObjectTypes || (exports.ObjectTypes = {}));
//# sourceMappingURL=ObjectTypes.js.map